import type Router from "vue-router"
import Routing from "@/store/session/routing"
import Notifications from "@/managers/session/notifications"
import Locations from "@/managers/location/locations"
import Organizations from "@/managers/organization/organizations"
import Preferences from "@/managers/system/preferences"
import {getLocationKey, isSameRoute} from "@/plugins/routerUtilities"

export default function(router: Router): void {
	router.beforeResolve((to, from, next) => {
		if (isSameRoute(to, from)) {
			next()
			return
		}

		const locationKey = getLocationKey(to)

		if (locationKey !== null) {
			Routing.setRoutingStatus("checkingLocation")
			Locations.setMainFromKey(locationKey)
				.then(location => {
					Organizations.setMainFromLocation(location.organizationId)
						.then(
							() => next(),
							reason => {
								Notifications.warning("Failed to set organization from location: " + reason)
								next({name: "notFound", params: {0: to.fullPath}})
							}
						)
				}, reason => {
					Notifications.warning("Failed to find location: " + reason)

					if (Preferences.preferredLocation === locationKey) {
						Preferences.preferredLocation = null
						next({name: "locationSelection"})
					} else
						next({name: "notFound", params: {0: to.fullPath}})
				})
		} else {
			if (Locations.main !== null) {
				Locations.clearMain()
				Notifications.debug("Clearing main location")
			}
			if (Organizations.wasMainSetFromLocation)
				Organizations.main = null
			next()
		}
	})
}
